import { createGlobalStyle } from "styled-components"
export const GlobalStyles = createGlobalStyle`
  body {
    background: ${({ theme }) => theme.body};
    color: ${({ theme }) => theme.text};
    /* transition: all 0.50s linear; */
    font-weight: 500;
    .border-top-theme{
      border-top: 1px solid ${({ theme }) => theme.toggleBorder
    }
  }
  .header-main {
    background: ${({ theme }) => theme.background};
    color: ${({ theme }) => theme.text};
    /* transition: all 0.50s linear; */
    .nav-link,.search_icon,.search_input{
        color: ${({ theme }) => theme.text};
      
    }
    .searchbar{
        background-color: ${({ theme }) => theme.bgHover};
    }

  }
  .dropdown-search {
    .list-movie{
        &:hover {
            background-color: ${({ theme }) => theme.bgHover};
        }
        h6,p{
            color: ${({ theme }) => theme.text};  
        }
    }
  }
  .dropdown-menu{
    background: ${({ theme }) => theme.background};
    color: ${({ theme }) => theme.text};
  }
  .modal-content{
    background: ${({ theme }) => theme.background} !important;
    color: ${({ theme }) => theme.text};
  }
  .nav-tabs {
    .nav-link,  &.disabled{
        color: ${({ theme }) => theme.text}; 
        &.active{
            background-color: ${({ theme }) => theme.background};
        }
    }
  }
  .tab-content{
    .tab-pane{
        background-color: ${({ theme }) => theme.background};
    }
    a{
        color: ${({ theme }) => theme.text}; 
    }
  }
  .bg-system{
    background-color: ${({ theme }) => theme.background};
  }
  .navbars {
  .list-group {
    background-color: ${({ theme }) => theme.background};
    border-radius: 5px;
    li {
     background-color: ${({ theme }) => theme.background};
      color: ${({ theme }) => theme.text};
      width: 100%;
      border: none !important;
      cursor: pointer;
     
      a {
        color: ${({ theme }) => theme.text};
        text-decoration: none;
        /* font-weight: 500; */
        &.active {
          color: #f9ab00;
        }
      }

      &:hover {
         a{
            color: #f9ab00 !important;
         }
        background-color: ${({ theme }) => theme.bgHover};
      }
    }
  }
}
.footer{
    background-color: ${({ theme }) => theme.background};
    a,p,h6{
        color: ${({ theme }) => theme.text};
    }
}
.browser-page{
  .bg-light-theme{
    background-color: ${({ theme }) => theme.background};
    color: ${({ theme }) => theme.text};
  }
}
  `
